import { useState , useEffect } from 'react';
import { priceFormat } from 'util/prices';
import { repareImage } from 'newFunctions/repareDataService';
import ModalProductTC from '../../Modal'
import styles from '../styles.module.sass'

const ProductModal = (props) => {

    const {
        showModal = false,
        handleClose,
        isMobile,
        title,
        product,
        clickAddProduct,
        clickPaymentProduct,
        image
    } = props


    return(
        showModal
            ? 
                <ModalProductTC
                    onClose={handleClose} 
                    isMobile={isMobile} 
                    type={isMobile === 'desktop' ? '' : 'full'} 
                    title={title} 
                    closeBody="modalPromos"
                >
                    <AddProductModal
                         producto={product}
                         handleClose={handleClose}
                         clickAddProduct={clickAddProduct}
                         clickPaymentProduct={clickPaymentProduct}
                         image={image}
                    />


                </ModalProductTC>
            : null
    )   
}

const AddProductModal = (props) => {
    const {
        producto,
        handleClose,
        clickAddProduct,
        clickPaymentProduct,
        image
    } = props

    const [ selectedStock, setSelectedStock ] = useState(1)

    useEffect(()=>{
        if(producto?.celebrate?.length === 1){
            document.querySelector('input[name="festejadoElegido"]').checked = true
        }
    },[producto?.celebrate])

    const clickAdd = () => {
        const festejado = document.querySelector('input[name="festejadoElegido"]:checked')?.value
        const error = document.querySelector(`.${styles?.festejado} .${styles?.h2}`)
        if(festejado){
            const response = { 
                quantity: selectedStock,
                user_selected: festejado
            }
            clickAddProduct(response)
        }else{
            error.classList.add(`${styles?.error}`)
        }
    }

    const clickPayment = () => {
        const festejado = document.querySelector('input[name="festejadoElegido"]:checked')?.value
        const error = document.querySelector(`.${styles?.festejado} .${styles?.h2}`)
        if(festejado){
            const response = { 
                quantity: selectedStock,
                user_selected: festejado
            }
            clickPaymentProduct(response)
            
        }else{
            error.classList.add(`${styles?.error}`)
        }
    }

    const handleClick = () => {
        const error = document.querySelector(`.${styles?.festejado} .${styles?.h2}`)
        error.classList.remove(`${styles?.error}`)
    }

    const link = `/producto/${producto?.id}/${producto?.title_seo}`

    return(
        <article className={`${styles?.cardModalProduct} ${styles?.modalAddProduct} `}>
            <div onClick={handleClose} className={styles?.closeBtn} aria-hidden >X</div>
            <div className={styles?.contImages}>
                <img src={repareImage(image)} alt={producto?.title} className={styles?.imageProduct} />
                <a href={link} target="_blank" className={styles?.link} rel="noreferrer">Ver detalle</a>
            </div>
            <div className={styles?.contProductInt}>
                <p className={styles?.title}>{producto?.title}</p>

                <div className={styles?.contPrices}>
                    <p className={styles?.salesPrice}>${priceFormat(producto?.pricing?.list_price)} MXN</p>
                </div>

                <div className={styles?.blockCantidad}>
                    <p className={styles?.h2}>Cantidad</p>
                    <CountStock 
                        stock={1}
                        maxStock={producto?.quantity_for_gift}
                        selectedStock={setSelectedStock}
                    />
                </div>

                <div className={styles?.festejado}>
                    <p className={styles?.h2}>¿A quién va dirgido tu regalo?</p>
                        {producto
                            ? 
                                <fieldset className={styles?.fieldsetData}>
                                    {producto?.celebrate
                                        ?
                                            producto?.celebrate.map( user => (
                                                <label htmlFor={`festejado_${user?.label?.id}`} key={user?.label?.value} onClick={handleClick} aria-hidden>
                                                    <input id={`festejado_${user?.label?.id}`} name="festejadoElegido" type="radio" value={user?.label?.value}  />
                                                    <span> { user?.label?.value } </span>
                                                </label>
                                            ) )
                                        : null
                                    }
                                </fieldset>
                            : null
                        }
                </div>
                
                <div>
                    <div className="btn secundaryButton btn-block" onClick={ clickAdd } aria-hidden="true" >Agregar a mi bolsa</div>
                    <div className="btn primaryButton btn-block" onClick={ clickPayment } aria-hidden="true" >Comprar ahora</div>
                </div>
            </div>
        </article>
    )
}

const CountStock = (props) => {
    const {
        stock,
        maxStock,
        selectedStock
    } = props

    const [ cant, setCant ] = useState(stock)
    const addStock = () => {
        if(cant < maxStock){
            setCant(cant + 1)
        }else{
            setCant(maxStock)
        }
    }
    const reduceStock = () => {
        if(cant > 1){
            setCant(cant - 1)
        }else{
            setCant(1)
        }
    }

    useEffect(()=>{
        if(cant){
            selectedStock(cant)
        }
    },[cant])

    return(
        <div className={maxStock > 1 ? styles?.contStock : `${styles?.contStock} ${styles?.disabled}`}>
            <p className={styles?.pmenos} onClick={reduceStock} aria-hidden>-</p>
            <p className={styles?.cantidadSel} >{cant}</p>
            <p className={styles?.pmas} onClick={addStock} aria-hidden>+</p>
        </div>
    )
}

export default ProductModal